import React from 'react'
import { observer } from 'mobx-react'
import { localisationMaster } from 'Localisation/Localisation'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import st from './DiscountMarkup.module.css'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import asideModalStore from 'Stores/asideModalStore'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import FormField from 'components/UI/AsideModal/Form/FormField'
import useLocalization from 'hooks/useLocalization'

const DiscountMarkup = () => {
  const { changeValue, check, modalValues, modalSettings } = asideModalStore
  const isDiscountMode = modalSettings.action === 'discount'

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      send_notification: 'Send notification',
      discount_type: 'Discount Type',
      surcharge_type: 'Surcharge Type',
      start_date: 'Start Date',
      today: 'Today',
      end_date: 'End Date',
      reset: 'Reset',
    },
  })

  return (
    <div className={st.form}>
      <FormField>
        <FormLabel isRequired>
          {isDiscountMode
            ? translate?.discount_type
            : translate?.surcharge_type}
          :
        </FormLabel>
        <SelectCustom
          placeholder={`${localisationMaster('select', 'groups/group', 'dors')} ${isDiscountMode ? localisationMaster('discount', 'groups/group', 'dors') : localisationMaster('surcharge', 'groups/group', 'dors')}`}
          apiLink={isDiscountMode ? 'groups/discounts' : 'groups/surcharges'}
          apiConfParams={{ limit: 999 }}
          sortKey='name'
          getOptionLabel={(opt) =>
            `${opt.name} (${opt.type_name}, ${opt.count}${opt.type === 1 ? 'тг' : '%'})`
          }
          valueID={
            modalValues[isDiscountMode ? 'discount_id' : 'surcharge_id'] || null
          }
          onChange={(o) =>
            changeValue(o.id, isDiscountMode ? 'discount_id' : 'surcharge_id')
          }
          isSearchable
          error={check(isDiscountMode ? 'discount_id' : 'surcharge_id')}
        />
      </FormField>
      <FormDateSelector
        placeholder={translate?.start_date}
        isRequired={true}
        button={{ name: translate?.today, action: 'today' }}
        label={translate?.start_date}
        onChange={(val) =>
          changeValue(dateFormat(val, 'YYYY-mm-dd'), 'date_from')
        }
        value={modalValues.date_from || ''}
        error={check('date_from')}
      />
      <FormDateSelector
        placeholder={translate?.end_date}
        isRequired={false}
        button={{ name: translate?.reset, action: 'reset' }}
        label={translate?.end_date}
        onChange={(val) =>
          changeValue(val ? dateFormat(val, 'YYYY-mm-dd') : null, 'date_until')
        }
        minDate={new Date(modalValues.date_from)}
        value={modalValues.date_until || ''}
      />
      <ToggleCheckbox
        label={translate?.send_notification}
        checked={modalValues.send_email}
        onChange={() => changeValue(!modalValues.send_email, 'send_email')}
      />
    </div>
  )
}

export default observer(DiscountMarkup)
